<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'reports',
};
</script>


// WEBPACK FOOTER //
// src/components/reports/reports.vue